const APP_CODE = import.meta.env.VITE_APP_CODE || 'APP'
const FALLBACK_STORAGE_NAMESPACE = import.meta.env.PROD ? 'PROD' : 'DEV'
const INITIAL_STORAGE_NAMESPACE =
  import.meta.env.VITE_APP_STORAGE_NAMESPACE || FALLBACK_STORAGE_NAMESPACE

export const normalizeAuthStorageNamespace = (value) => {
  if (typeof value !== 'string') return null

  const normalizedValue = value.trim().toUpperCase()
  return /^[A-Z0-9_-]+$/.test(normalizedValue) ? normalizedValue : null
}

export const createAuthTokenStorageKeys = (storageNamespace, appCode = APP_CODE) => {
  const normalizedNamespace = normalizeAuthStorageNamespace(storageNamespace)
  if (!normalizedNamespace) {
    throw new TypeError('Invalid auth storage namespace')
  }

  const normalizedAppCode = String(appCode || 'APP').trim() || 'APP'
  return Object.freeze({
    accessTokenStorageKey: `${normalizedAppCode}_${normalizedNamespace}_AUTHENTICATOR_access_token`,
    refreshTokenStorageKey: `${normalizedAppCode}_${normalizedNamespace}_AUTHENTICATOR_refresh_token`
  })
}

const initialStorageNamespace =
  normalizeAuthStorageNamespace(INITIAL_STORAGE_NAMESPACE) || FALLBACK_STORAGE_NAMESPACE
const initialTokenStorageKeys = createAuthTokenStorageKeys(initialStorageNamespace)
let authStorageRevision = 0

export const getAuthStorageRevision = () => authStorageRevision

export const AUTH_CONFIG = {
  authApiUrl: import.meta.env.VITE_APP_API_URL ?? '-', // todo handle of not
  authUrl: import.meta.env.VITE_APP_URL ?? 'http://localhost:3003',
  appUrl: import.meta.env.VITE_APP_REDIRECT_URL ?? 'http://localhost:3000',
  authAppPath: import.meta.env.VITE_APP_AUTH_PATH ?? 'handle-login',
  autoAuth:
    import.meta.env.VITE_APP_AUTO_AUTH === undefined
      ? true
      : import.meta.env.VITE_APP_AUTO_AUTH === 'true',
  timestampValidationMode: 'off',
  storageNamespace: initialStorageNamespace,
  ...initialTokenStorageKeys,
  authorizationTokenUrlParamKey: 'code'
}

export const setAuthStorageNamespace = (storageNamespace) => {
  const normalizedNamespace = normalizeAuthStorageNamespace(storageNamespace)
  if (!normalizedNamespace) {
    throw new TypeError('Invalid auth storage namespace')
  }

  const tokenStorageKeys = createAuthTokenStorageKeys(normalizedNamespace)
  if (AUTH_CONFIG.storageNamespace !== normalizedNamespace) authStorageRevision += 1
  AUTH_CONFIG.storageNamespace = normalizedNamespace
  Object.assign(AUTH_CONFIG, tokenStorageKeys)

  return tokenStorageKeys
}
